/**
 * The two decision icons for the reference-projects step-1 options.
 *
 * Inline SVG rather than SWAN `Icon`: neither glyph exists in SWAN's icon set, and these are the
 * exact paths the pilot ships. Defined once here — the pilot duplicated each of them across its
 * selector and its message view, so a change to one silently diverged from the other.
 *
 * `aria-hidden` on both: each icon sits beside a text label that already names the option, so
 * exposing it to a screen reader would only repeat that label.
 */
export function FolderXIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9.5 10.5 5 5m0-5-5 5M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"
            />
        </svg>
    );
}

export function FolderPlusIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20m0 0a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2z"
            />
        </svg>
    );
}
